import { ConversationPhase as r } from "./types.js";
const l = (t) => {
  if (!t)
    return null;
  const e = t.split("/");
  if (e.length < 3)
    return null;
  const n = e[1], s = e[2].substring(1);
  if (n.length === 8) {
    const i = n.substring(0, 4), o = n.substring(4, 6), a = n.substring(6, 8), u = (/* @__PURE__ */ new Date(`${i}-${a}-${o}`)).toLocaleDateString(
      "en-AU",
      {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
        timeZone: "Australia/Sydney"
      }
    );
    return { version: s, date: u };
  } else
    return null;
};
function f(t) {
  return !!t.version;
}
function d(t) {
  return typeof t == "string" && !!t && ![
    r.report_ready,
    r.saved_report,
    r.sent_to_council
  ].includes(t);
}
function g(t) {
  return typeof t == "string" && !!t && [r.report_ready, r.amendment].includes(
    t
  );
}
function p(t) {
  return typeof t == "string" && !!t && [
    r.saved_report,
    r.sent_to_council
  ].includes(t);
}
function y(t) {
  if (t == null) return "";
  const e = t.toLowerCase().split(" ");
  for (let n = 0; n < e.length; n++)
    e[n] = e[n].charAt(0).toUpperCase() + e[n].substring(1);
  return e.join(" ");
}
function C(t) {
  if (!t) return "";
  const e = t.charAt(0).toUpperCase(), n = t.slice(1).toLowerCase();
  return e + n;
}
export {
  d as a,
  g as b,
  p as c,
  l as e,
  f as i,
  C as s,
  y as t
};
//# sourceMappingURL=utils-CIU8rhkz.js.map
